import { briefingTeamUpdatesAPI } from "components/Apis/Briefing";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const UnconfimedDeliveryTimesBoard = ({ }) => {
    const [unconfirmedDeliveryTimeOrders, setUnconfirmedDeliveryTimeOrders] = useState(null);

    const briefing = useSelector((state) => state.briefing.line);
    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);


    useEffect(() => {
        if (!(briefing == "Old Briefings")) {
            (async () => {
                const data = await briefingTeamUpdatesAPI.getUnconfirmedDeliveryTimeOrders();
                setUnconfirmedDeliveryTimeOrders(data.data);
            })();
        }
        else {
            setUnconfirmedDeliveryTimeOrders(null);
        }

    }, [startDate, endDate, searchTerm, briefing]);

    return (
        <>
            {
                unconfirmedDeliveryTimeOrders && unconfirmedDeliveryTimeOrders.length > 0 && (
                    <>
                        <p className="pop-badge">Orders With Unconfirmed Delivery Times:</p>
                        <table className="briefing-table sub-section-table">
                            <thead>
                                <tr>
                                    <th>Pro #</th>
                                    <th>Vehicle Size</th>
                                    <th>Deliver To</th>
                                    <th>Delivery Date</th>
                                    <th>Outbound</th>
                                    <th>Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                {unconfirmedDeliveryTimeOrders ? (
                                    unconfirmedDeliveryTimeOrders.map((order, index) => (
                                        <tr key={index}>
                                            <td>{order.order_no} {order.order_group} {order.backorder?.order_no}</td>
                                            <td>{order.vehicle_size}</td>
                                            <td>{order.delivery_city_state}</td>
                                            <td>{order.delivery_date}</td>
                                            <td>{order.bus}</td>
                                            <td>{order.notes}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5">No unconfirmed delivery time orders found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <hr />
                    </>
                )
            }
        </>
    );
};

export default UnconfimedDeliveryTimesBoard;